import { esc } from "../ui/format.js";
import { uiGet } from "../ui/kit.js";
import { getCurrentTab } from "../app/shell.js";

/**
 * 🗺️ Your first year (2026-10-24): on Overview for the first 12 months, the next three goals
 * (GET /api/goals, backend/progression.py) with their progress and a "Show me" button that opens
 * the tab and flashes the button that does it. New players are never lost among the tabs.
 */

// goal -> (tab, what to flash: a selector or a button's words)
const FY_SHOW = {
  launch: ["products", "Launch"], second_product: ["products", "Launch"], survive: ["financials", "Cash"],
  profit: ["operations", "budget"], first_deal: ["deals", "Request a meeting"], financing: ["banking", "loan"],
  second_country: ["government", "#btn-start-country-expansion"], three_regions: ["government", "#btn-start-country-expansion"],
  number_one: ["competitors", "market"], acquire: ["ma", "target"], ipo: ["publicmarkets", "IPO"], legacy: ["executives", "succession"],
};

function fyFind(root, what) {
  if (what.startsWith("#") || what.startsWith(".") || what.startsWith("[")) return root.querySelector(what);
  const w = what.toLowerCase();
  return [...root.querySelectorAll("button, a, h2, h3, h4, summary")].find((el) => !el.closest(".fy, .att-banner") && el.textContent.toLowerCase().includes(w)) || null;
}

async function fyShow(key) {
  const [tab, what] = FY_SHOW[key] || [];
  if (!tab || !window.ges) return;
  await window.ges.showTab(tab);
  for (let k = 0; k < 12; k += 1) {
    const main = document.getElementById("main-content");
    const el = main && fyFind(main, what);
    if (el) { if (window.gesFlash) window.gesFlash(el); else el.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
    await new Promise((r) => setTimeout(r, 250));
  }
}

const _fyOverview = window.renderOverview;
window.renderOverview = async function (main, snap) {
  await _fyOverview(main, snap);
  if (getCurrentTab() !== "overview" || !snap || snap.month > 12) return;
  let g;
  try { g = await uiGet("/goals"); } catch (e) { return; }
  if (getCurrentTab() !== "overview" || !g || !(g.next || []).length) return;
  const box = document.createElement("section");
  box.className = "fy";
  box.innerHTML = `<div class="fy-head"><h3>🗺️ Your first year</h3><p>Month ${snap.month} of 12 · ${g.completed}/${g.total} goals reached. Three to aim at next:</p></div>
    <div class="fy-grid">${g.next.slice(0, 3).map((x) => `<article class="fy-goal">
      <b>${esc(x.title)}</b><span>${esc(x.detail || "")}</span>
      ${x.progress_pct !== null && x.progress_pct !== undefined ? `<div class="fy-bar"><i style="width:${Math.max(3, Math.min(100, x.progress_pct))}%"></i></div>` : ""}
      ${FY_SHOW[x.key] ? `<button type="button" data-fy="${esc(x.key)}">Show me →</button>` : ""}</article>`).join("")}</div>`;
  const adv = main.querySelector(".adv");
  const anchor = adv || main.querySelector(".panel-title");
  if (anchor) anchor.insertAdjacentElement("afterend", box); else main.prepend(box);
  box.querySelectorAll("[data-fy]").forEach((b) => b.addEventListener("click", () => fyShow(b.dataset.fy)));
};

export { fyShow };
